module.exports = __webpack_public_path__ + "static/media/bottom.c4f24c88.webp";